export function SiteHeader() {
  const isBakesPage = window.location.pathname.replace(/\/+$/, '') === '/bakes';

  return (
    <>
      <div className="announcement">A little something, made with a lot of love <span aria-hidden="true">*</span></div>
      <header className="site-header">
        <a className="wordmark" href="/" aria-label="Something Sweet home">
          <img className="wordmark__image" src="/logo.svg" alt="" />
          <span className="wordmark__name">Something<br /><em>Sweet</em></span>
        </a>
        <nav className="site-nav" aria-label="Main navigation">
          <a href="/bakes" aria-current={isBakesPage ? 'page' : undefined}>All the bakes</a>
          <a href="/#our-story">Our little story</a>
        </nav>
        <a className="header-order" href="/#order">Make an enquiry <span aria-hidden="true">↗</span></a>
      </header>
    </>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <a className="wordmark wordmark--footer" href="/" aria-label="Something Sweet, back to top">
        <img className="wordmark__image" src="/logo.svg" alt="" />
        <span className="wordmark__name">Something<br /><em>Sweet</em></span>
      </a>
      <p>Made by hand. Shared with love.</p>
      <a className="footer-top" href="/#top">Back to the top <span aria-hidden="true">↑</span></a>
    </footer>
  );
}